module.exports = __webpack_public_path__ + "static/media/music-affects-productivity.72bf22b0.svg";